import React, { useState } from 'react';
import { FullBackground } from '../../../components/FullBackground';

type Props = {
  className?: string;
};

function InlineFAQ({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="pt-6 justify-items-center">
      <dt className=" text-lg justify-items-center align-items-middle">
        <button
          className="text-left w-full flex  items-start text-gray-400 focus:outline-none"
          onClick={() => {
            setOpen(!open);
          }}
        >
          <span className="font-medium text-gray-900">{question}</span>
          <span className="ml-6 h-7 items-center ">
            <svg
              className={`transition duration-500 ease-in-out h-6 w-6 transform ${
                open && 'rotate-180 '
              }`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 15l7-7 7 7"
              />
            </svg>
          </span>
        </button>
      </dt>
      {open && (
        <dd className="mt-2 pr-12">
          <p className="text-base text-gray-700">{answer}</p>
        </dd>
      )}
    </div>
  );
}

const ProductFAQs: React.FC<Props> = ({ className }) => {
  return (
    <>
      <FullBackground color={'bg-gray-100'} isSlanted={false}>
        <div
          style={{ marginLeft: '50vw', marginRight: '50vw' }}
          className={className}
          id={'order-pay'}
        >
          <div className=" ">
            <div className="relative max-w-xl max-w-7xl">
              <div className="bg-white px-5 pb-6 pt-6 rounded-lg shadow-lg">
                <div className="max-w-7xl mx-auto ">
                  <h3 className="text-xl leading-6 font-semibold text-gray-900">
                    FAQs
                  </h3>
                  <dl className="  mt-2 md:gap-x-8 space-y-6  divide-y divide-gray-200">
                    <InlineFAQ
                      key={'Q1'}
                      question={'How does this impact human interaction?'}
                      answer={
                        'More human interaction and better service are a guarantee with\n' +
                        '          TableTab. We handle the busy work of handling order\n' +
                        '          and payment so your staff can spend more time seating\n' +
                        '          guests, recommending items, upselling, and more.'
                      }
                    />
                    <InlineFAQ
                      key={'Q2'}
                      question={'What is the average tip on TableTab orders?'}
                      answer={
                        'The average tip across our partners is 22% and because\n' +
                        '                          staff cover more tables with TableTab, a higher volume\n' +
                        "                          of tips are collected as well. (That's probably why\n" +
                        '                          every server who has used TableTab loves it).'
                      }
                    />
                    <InlineFAQ
                      key={'Q3'}
                      question={'How quickly can I get started?'}
                      answer={
                        'We have the fastest setup process in the industry.\n' +
                        '                          Create an account to import your menu, generate your\n' +
                        "                          QR code, and you're good to go. You have total control\n" +
                        '                          and can capture orders within an hour if desired.'
                      }
                    />
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FullBackground>
    </>
  );
};

export default ProductFAQs;
